import { Logo } from "@kui-react/logo";
import { FormattedMessage } from 'react-intl';

import './index.css';

function UserAvatarIcon() {
  return (
    <svg className="header-auth-avatar-icon" viewBox="0 0 24 24" width={22} height={22} aria-hidden focusable="false">
      <path
        fill="currentColor"
        d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
      />
    </svg>
  );
}

/**
 * @param {object} props
 * @param {{ primary: string, secondary: string }|null} [props.signedInUser]
 */
export const PageHeader = ({ signedInUser = null }) => {
  const accountLabel =
    signedInUser?.secondary && signedInUser?.primary
      ? `Signed in as ${signedInUser.primary}, ${signedInUser.secondary}`
      : signedInUser?.primary || '';

  return (
    <div className="header-container">
      <div className="header-top-strip">
        <div className="header-top-row">
          <div className='header-logo'>
            <div><Logo name='all_white_text_horizontal' /></div>
          </div>
          {signedInUser ? (
            <div className="header-account-cluster">
              <div
                className="header-auth-block"
                role="status"
                aria-label={accountLabel}
              >
                <span className="header-auth-avatar" aria-hidden>
                  <UserAvatarIcon />
                </span>
                <span className="header-auth-text">
                  <span className="header-auth-primary">{signedInUser.primary}</span>
                  {signedInUser.secondary ? (
                    <span className="header-auth-secondary">{signedInUser.secondary}</span>
                  ) : null}
                </span>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <div className='header-bar'>
        <div className="header-bar-inner">
          <div className="header-title">
            <FormattedMessage id="app-title" defaultMessage="GeForce NOW" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
